/**
 * Form Button Handler
 * Auto-selects a form dropdown option when collection grid item is clicked
 */


document.addEventListener('DOMContentLoaded', function() {
  // Levenshtein distance algorithm to find string similarity
  function levenshteinDistance(str1, str2) {
    const m = str1.length;
    const n = str2.length;
    const dp = Array.from({ length: m + 1 }, () => Array(n + 1).fill(0));
  
    for (let i = 0; i <= m; i++) dp[i][0] = i;
    for (let j = 0; j <= n; j++) dp[0][j] = j;
  
    for (let i = 1; i <= m; i++) {
      for (let j = 1; j <= n; j++) {
        if (str1[i - 1] === str2[j - 1]) {
          dp[i][j] = dp[i - 1][j - 1];
        } else {
          dp[i][j] = 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
        }
      }
    }
    return dp[m][n];
  }
  
  // Calculate similarity score (0-1, where 1 is identical)
  function getSimilarityScore(str1, str2) {
    const maxLen = Math.max(str1.length, str2.length);
    if (maxLen === 0) return 1;
    const distance = levenshteinDistance(str1, str2);
    return 1 - (distance / maxLen);
  }

  // Helper: scroll the form field into view
  function scrollFieldIntoView(el) {
    const target = el.closest('.form-field, .frm_form_field, form') || el;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }


    // const hashLinks = document.querySelectorAll('.banner-image__btn[href^="#"]');

    // hashLinks.forEach(function(link) {
    //   link.addEventListener('click', function(event) {
    //     const href = link.getAttribute('href');
    //     console.log(href);

    //     // Skip empty "#" links (often used as JS hooks / no-ops)
    //     if (!href || href === '#') return;

    //     const targetId = href.slice(1); // remove the leading "#"
    //     const targetElement = document.getElementById(targetId);
    //     console.log(targetElement);

    //     if (targetElement) {
    //       event.preventDefault(); // stop the default instant jump
    //       targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });

    //       // Optional: update the URL hash without jumping
    //       history.pushState(null, '', href);
    //     }
    //   });
    // });

  
  // Get all collection grid item outer anchor tags
  const anchorElements = document.querySelectorAll('.list-collections__item__outer');
  
  if (anchorElements.length === 0) {
    return;
  }

  let selectField = null;
  let isInitialized = false;

  // Function to initialize the click handlers once the form field is found
  function initializeClickHandlers() {
    if (isInitialized) return;
    
    isInitialized = true;

    // Add click event listener to each anchor element
    anchorElements.forEach((element, index) => {
      element.addEventListener('click', function(event) {
        const contentValue = element.getAttribute('value');
        
        if (!contentValue || !selectField) {
          return;
        }

        // For Helium Custom Fields, we need to find the actual input/select within the field
        let inputToSet = selectField;
        
        // If selectField is a div, try to find an input or select inside
        if (selectField.tagName === 'DIV') {
          const innerSelect = selectField.querySelector('select');
          const innerInput = selectField.querySelector('input');
          inputToSet = innerSelect || innerInput || selectField;
          
          if (innerSelect) {
          } else if (innerInput) {
          }
        }

        // Loop through select options to find a match
        const options = inputToSet.querySelectorAll ? inputToSet.querySelectorAll('option') : [];
        
        // Special case: if the value contains "BOTH", select BOTH option directly
        const contentValueNormalized = contentValue.toUpperCase().replace(/[\s_]/g, '');
        if (contentValueNormalized.includes('BOTH')) {
          const bothOption = Array.from(options).find(opt => opt.value === 'BOTH');
          if (bothOption) {
            inputToSet.value = 'BOTH';
            const event = new Event('change', { bubbles: true });
            inputToSet.dispatchEvent(event);
            scrollFieldIntoView(inputToSet); 
            return;
          }
        }
        
        let bestMatch = null;
        let bestScore = 0;
        const SIMILARITY_THRESHOLD = 0.6; // 60% similarity required
        
        options.forEach((option) => {
          const optionValue = option.value;
          const optionText = option.textContent.trim();
          
          if (!optionValue) return; // Skip empty options
          
          // Normalize values for comparison
          const normalizedContent = contentValue.toUpperCase().replace(/[\s_]/g, '');
          const normalizedValue = optionValue.toUpperCase().replace(/[\s_]/g, '');
          const normalizedText = optionText.toUpperCase().replace(/[\s_]/g, '');
          
          // Calculate similarity scores
          const scoreValue = getSimilarityScore(normalizedContent, normalizedValue);
          const scoreText = getSimilarityScore(normalizedContent, normalizedText);
          const bestOptionScore = Math.max(scoreValue, scoreText);
          
          if (bestOptionScore > bestScore) {
            bestScore = bestOptionScore;
            bestMatch = option;
          }
        });
        
        if (bestMatch && bestScore >= SIMILARITY_THRESHOLD) {
          // Select the best matching option
          inputToSet.value = bestMatch.value;
          
          // Trigger change event to notify Helium form
          const event = new Event('change', { bubbles: true });
          inputToSet.dispatchEvent(event);
          scrollFieldIntoView(inputToSet); 
        }
      });
    });
  }

  // Function to scan for the form field
  function findFormField() {
    // Try to find the field by name attribute (most reliable)
    let field = document.querySelector('select[name="what_are_you_looking_for"]');
    
    if (field) {
      selectField = field;
      initializeClickHandlers();
      return true;
    }

    // Try to find the field by data-cf-column-key
    field = document.querySelector('[data-cf-column-key="what_are_you_looking_for"]');
    
    if (field) {
      selectField = field;
      initializeClickHandlers();
      return true;
    }

    // Try to find it by id (using getElementById to handle numeric IDs)
    field = document.getElementById('620126');
    if (field) {
      selectField = field;
      initializeClickHandlers();
      return true;
    }

    return false;
  }

  // Try to find the field immediately
  if (findFormField()) {
  } else {
    
    // Use MutationObserver to detect when the form loads dynamically
    const observer = new MutationObserver(function(mutations) {
      if (findFormField()) {
        observer.disconnect();
      }
    });

    // Watch for changes in the document
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-cf-column-key', 'class']
    });

    // Also try again after a short delay (in case form is partially loaded)
    setTimeout(() => {
      if (!isInitialized && findFormField()) {
        observer.disconnect();
      }
    }, 2000);
  }
});
